import TextLinkHorizontal from '../../../components/common/card/TextLinkHorizontal'
import TitleSection from '../TitleSection'
import YoutubePlayer from '../video/YoutubePlayer'

interface Item {
  title: string
  url: string
}

interface MediaTabProps {
  media: {
    youtubes: {
      code: string
    }[]
    articles: Item[]
  }
  onEnd: (i: number) => void
  checkYoutube?: () => void
  onPlay?: (i: number, playbackTime: number) => void
  onPause?: (i: number) => void
  onArticleClick: (item: Item) => void
  isMobile: boolean
}

const MediaTab = ({ media, onEnd, checkYoutube, onPlay, onPause, onArticleClick, isMobile }: MediaTabProps) => {
  console.log(media)

  return (
    <div className="pb-[16px]">
      {media?.youtubes?.length > 0 && <TitleSection title={'Video'} />}

      <div className="mb-[32px]">
        {media.youtubes?.map((item, i) => (
          <YoutubePlayer
            clx={isMobile && ' h-[50vw] w-[100%]'} // ratio 16:9
            item={item}
            onEnd={onEnd}
            onPlay={onPlay}
            onPause={onPause}
            checkYoutube={checkYoutube}
            key={i}
          />
        ))}
      </div>

      {media.articles?.length > 0 && <TitleSection title={'News'} />}
      {media.articles?.map((item, i) => (
        <TextLinkHorizontal item={item} key={i} onClick={() => onArticleClick(item)} />
      ))}
    </div>
  )
}

export default MediaTab
